// extracted by mini-css-extract-plugin
module.exports = {"card":"featuresHighlightsCard-module--card--CMDyj","imageContainer":"featuresHighlightsCard-module--imageContainer--34kq6"};